// // 

// import { useEffect, useState } from "react";
// import moment from "moment";

// export default function CustomDateFilter({
//   onChange,
//   isFilterCleared,
//   className,
//   label,
//   onTypeChange,
//   type: initialType,
//   dateFilterPopup
// }) {
//   const [type, setType] = useState(initialType);



//   const handleSelectChange = (val) => {
//     setType(val);
//     onTypeChange?.(val);

//     let start, end;
//     const today = moment();

//     switch (val) {
//       case "today":
//         start = today.clone();
//         end = today.clone();
//         break;

//       case "7":
//         start = today.clone().subtract(6, "days");
//         end = today.clone();
//         break;

//       case "15":
//         start = today.clone().subtract(14, "days");
//         end = today.clone();
//         break;

//    case "1m":
//   start = today.clone().subtract(29, "days");
//   end = today.clone();
//   break;

//    case "6m":
//   start = today.clone().subtract(179, "days");
//   end = today.clone();
//   break;

//       case "custom":
//         return;

//       default:
//         return;
//     }

//     const s = start.format("YYYY-MM-DD");
//     const e = end.format("YYYY-MM-DD");

//     setStartDate(s);
//     setEndDate(e);

//     onChange?.([s, e]); // ✅ parent update
//   };

// useEffect(() => {
//   if (type !== "custom") return;

//   if (
//     dateFilterPopup?.from !== startDate ||
//     dateFilterPopup?.to !== endDate
//   ) {
//     setStartDate(dateFilterPopup.from);
//     setEndDate(dateFilterPopup.to);
//   }
// }, [dateFilterPopup]);

//   // const handleCustomChange = (s, e) => {
//   //   setStartDate(s);
//   //   setEndDate(e);
//   //   onChange?.([s, e]);
//   // };

//  const handleCustomChange = (s, e) => {
//   setStartDate(s);
//   setEndDate(e);

//   onTypeChange?.("custom");

//   // ✅ Only call when both selected properly
//   if (s && e && moment(e).isSameOrAfter(s)) {
//     onChange?.([s, e]);
//   }
// };

// useEffect(() => {
//   if (initialType) {
//     handleSelectChange(initialType);
//   }
// }, []);

//   useEffect(() => {
//     if (isFilterCleared === true) {
//       handleSelectChange("7");
//     }
//   }, [isFilterCleared]);

//   return (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "flex-end",
//         gap: 10,
//         marginTop: label ? 4 : 0,
//       }}
//     >
//       {/* SAME UI — untouched */}
//       <div style={{ display: "flex", flexDirection: "column" }}>
//         {label && <label style={{ marginBottom: 4 }}>{label}</label>}

//         <select
//           value={type}
//           onChange={(e) => handleSelectChange(e.target.value)}
//           style={{
//             width: type === "custom" ? "150px" : "220px",
//             padding: !className && "7px 10px",
//             borderRadius: 8,
//             border: "1px solid #ccc",
//           }}
//           className={className}
//         >
//           <option value="today">Today</option>
//           <option value="7">7 Days</option>
//           <option value="15">15 Days</option>
//           <option value="1m">1 Month</option>
//           <option value="6m">6 Months</option>
//           <option value="custom">Custom</option>
//         </select>
//       </div>

//       {type === "custom" && (
//         <>
//           <div>
//             <input
//               type="date"
//             value={dateFilterPopup.from}
//               onChange={(e) =>
//                 handleCustomChange(e.target.value, endDate)
//               }
//               style={{
//                 width: 150,
//                 padding: !className && "6px 10px",
//                 borderRadius: 8,
//                 border: "1px solid #ccc",
//               }}
//               className={className}
//             />
//           </div>

//           <div>
//             <input
//               type="date"
//                 value={dateFilterPopup.from}
//               min={startDate}
//               onChange={(e) =>
//                 handleCustomChange(startDate, e.target.value)
//               }
//               style={{
//                 width: 150,
//                 padding: !className && "6px 10px",
//                 borderRadius: 8,
//                 border: "1px solid #ccc",
//               }}
//               className={className}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import moment from "moment";

export default function CustomDateFilter({
  onChange,
  isFilterCleared,
  className,
  label,
  onTypeChange,
  type: initialType = "7",
  dateFilterPopup,
}) {
  const [type, setType] = useState(initialType);

  // ✅ SYNC TYPE WITH PARENT (MOST IMPORTANT FIX)
  useEffect(() => {
    if (initialType) {
      setType(initialType);
    }
  }, [initialType]);

  // 🔥 HANDLE PRESET CHANGE
  const handleSelectChange = (val) => {
    setType(val);
    onTypeChange?.(val);

    if (val === "custom") return;

    let start, end;
    const today = moment();

    switch (val) {
      case "today":
        start = today.clone();
        end = today.clone();
        break;

      case "7":
        start = today.clone().subtract(6, "days");
        end = today.clone();
        break;

      case "15":
        start = today.clone().subtract(14, "days");
        end = today.clone();
        break;

      case "1m":
        start = today.clone().subtract(29, "days");
        end = today.clone();
        break;

      case "6m":
        start = today.clone().subtract(179, "days");
        end = today.clone();
        break;

      default:
        return;
    }

    onChange?.([
      start.format("YYYY-MM-DD"),
      end.format("YYYY-MM-DD"),
    ]);
  };

  // 🔥 CUSTOM DATE CHANGE
  const handleCustomChange = (s, e) => {
    setType("custom");
    onTypeChange?.("custom");

    if (s && e && moment(e).isSameOrAfter(s)) {
      onChange?.([s, e]);
    }
  };

  // 🔥 RESET HANDLER
  useEffect(() => {
    if (isFilterCleared) {
      handleSelectChange("7");
    }
  }, [isFilterCleared]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        gap: 10,
        marginTop: label ? 4 : 0,
      }}
    >
      {/* SELECT */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        {label && <label style={{ marginBottom: 4 }}>{label}</label>}

        <select
          value={type}
          onChange={(e) => handleSelectChange(e.target.value)}
          style={{
            width: type === "custom" ? "150px" : "220px",
            padding: !className && "7px 10px",
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
          className={className}
        >
          <option value="today">Today</option>
          <option value="7">7 Days</option>
          <option value="15">15 Days</option>
          <option value="1m">1 Month</option>
          <option value="6m">6 Months</option>
          <option value="custom">Custom</option>
        </select>
      </div>

      {/* CUSTOM DATE INPUTS */}
      {type === "custom" && (
        <>
          <input
            type="date"
            value={dateFilterPopup?.from || ""}
            onChange={(e) =>
              handleCustomChange(e.target.value, dateFilterPopup?.to)
            }
            style={{
              width: 150,
              padding: !className && "6px 10px",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
            className={className}
          />

          <input
            type="date"
            value={dateFilterPopup?.to || ""}
            min={dateFilterPopup?.from}
            onChange={(e) =>
              handleCustomChange(dateFilterPopup?.from, e.target.value)
            }
            style={{
              width: 150,
              padding: !className && "6px 10px",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
            className={className}
          />
        </>
      )}
    </div>
  );
}